<template>
  <div class="pay-wrap">
    <div class="pay-head-box">
      <div class="line-box"><img src="@/assets/img/success_icon.png" /></div>
      <div class="tips_zh">支付成功</div>
      <div class="btn-box"><van-button round type="ponhu" block @click.stop="checkOrder">查看订单</van-button></div>
    </div>
    <div class="order-info">
      <div class="title">
        <div class="fz24">订单信息</div>
        <div class="fz20">实付金额：￥{{order.orderAmount}}</div>
      </div>
      <div class="item">
        <div>订单编号：{{order.soNumber}}</div>
      </div>
      <div class="item">
        <div>支付方式：{{order.paymentName}}</div>
        <div>{{order.createTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBriefOrderInfo } from '@/api/order'

export default {
  data() {
    return {
      order: {}
    }
  },
  created () {
    var so = this.$route.query.so;
    var token = this.$store.getters.token;
    getBriefOrderInfo({ userToken: token, soNumber: so }).then(res => {
      this.order = res
    })
  },
  methods: {
    checkOrder() {
      this.$router.push({ name: 'shopOrderDetail', params: { oid: this.order.soNumber } })
    }
  }
}
</script>

<style lang="less" scoped>
.pay-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh);
  background: #fff;
  width: 750px;
  .pay-head-box {
    text-align: center;
    padding-top: 158px;
    .line-box {
      display:inline-block;
      img {
        width: 70px;
        height: 70px;
      }
    }
    .tips_zh{
      font-size: 36px;
      font-weight: 400;
      color: #282828;

    }
    .btn-box {
      margin-top: 60px;
      padding: 0 235px;
    }
  }
  .order-info {
    margin-top: 128px;
    margin-left: 24px;
    width: 702px;
    background: #F7F7F7;
    border-radius: 16px;
    padding-bottom: 24px;
    .title {
      padding: 16px 24px 0;
      display: flex;
      justify-content: space-between;
      height: 64px;
      font-size: 24px;
      font-weight: 500;
      color: #222222;
      line-height: 64px;
    }
    .item {
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      height: 36px;
      font-size: 20px;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
    }
  }
}
</style>


